import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const BakingProcess = ({ process }) => {
  return (
    <div className="bg-card rounded-xl p-8 shadow-warm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="ChefHat" size={28} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="font-serif text-2xl font-semibold text-foreground">
            Behind the Scenes
          </h2>
          <p className="text-sm text-muted-foreground">
            Traditional Italian baking techniques
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {process.steps?.map((step, index) => (
          <div key={step?.id} className="flex gap-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center text-primary-foreground font-semibold">
                {index + 1}
              </div>
            </div>
            <div className="flex-1">
              <div className="relative h-48 rounded-lg overflow-hidden mb-3">
                <Image
                  src={step?.image}
                  alt={step?.imageAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="font-serif text-lg font-semibold text-foreground mb-2">
                {step?.title}
              </h3>
              <p className="text-sm text-muted-foreground mb-2">
                {step?.description}
              </p>
              <div className="flex items-center gap-2 text-sm text-primary">
                <Icon name="Clock" size={16} />
                <span>{step?.duration}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-muted/50 rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <p className="text-sm text-foreground">
            <strong>Master Baker's Note:</strong> {process.masterNote}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BakingProcess;